export const addIntlKey = (obj, arr) =>
  arr.map((item) => {
    return { ...item, intlText: obj[item.key] }
  })
